import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Card from "components/card";
import Button from "components/button";
import { getAnnouncement, updateAnnouncement } from "services/announcements";
import { getCsrfToken } from "api";
import { useToast } from "components/Toast";

const EditAnnouncement = () => {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      try {
        const { data } = await getAnnouncement(id);
        const ann = data?.data || data;
        setTitle(ann.title || "");
        setBody(ann.body || ann.content || "");
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;
    setSubmitting(true);
    try {
      await updateAnnouncement(id, { title, body });
      navigate("/admin/announcements");
      toast.showSuccess("Announcement updated");
    } catch (err) {
      console.error("Failed to update announcement", err);
      const anyE = err as any;
      let message =
        anyE?.response?.data?.message || anyE?.message || String(err);
      if (anyE?.response?.data?.errors) {
        const errs = anyE.response.data.errors;
        message = Object.values(errs).flat()[0] || message;
      }
      toast.showError(message || "Failed to update announcement");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading)
    return (
      <Card extra="w-full p-4">
        <div>Loading...</div>
      </Card>
    );

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Edit Announcement</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            className="mt-1 block w-full rounded-md border border-gray-300 bg-white text-gray-900 placeholder-gray-400 shadow-sm dark:border-white/10 dark:bg-navy-800 dark:text-white dark:placeholder-white/40"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Body
          </label>
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            required
            rows={6}
            className="mt-1 block w-full rounded-md border border-gray-300 bg-white text-gray-900 placeholder-gray-400 shadow-sm dark:border-white/10 dark:bg-navy-800 dark:text-white dark:placeholder-white/40"
          />
        </div>
        <div>
          <Button type="submit" disabled={submitting}>
            {submitting ? "Updating..." : "Update"}
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default EditAnnouncement;
